module.exports = __webpack_public_path__ + "static/media/hall-P12.20c562ef.svg";